import React from 'react';

const Terms = () => {
  return (
    <div style={{ minHeight: '100vh', padding: '120px 20px 80px', backgroundColor: '#ffffff' }}>
      <div style={{ maxWidth: '900px', margin: '0 auto' }}>
        {/* Header */}
        <div style={{ marginBottom: '60px', paddingBottom: '40px', borderBottom: '2px solid #e5e7eb' }}>
          <div style={{ 
            display: 'inline-block',
            padding: '8px 20px',
            backgroundColor: '#f3f4f6',
            borderRadius: '24px',
            marginBottom: '24px'
          }}>
            <span style={{ color: '#6b7280', fontSize: '14px', fontWeight: '600', letterSpacing: '0.5px' }}>
              LEGAL
            </span>
          </div>
          <h1 style={{ 
            fontSize: '48px', 
            fontWeight: '800', 
            color: '#1f2937',
            marginBottom: '16px',
            letterSpacing: '-0.5px'
          }}>
            Terms of Service
          </h1>
          <p style={{ fontSize: '17px', color: '#6b7280' }}>
            Last updated: <strong>January 7, 2025</strong>
          </p>
        </div>

        {/* Content */}
        <div style={{ fontSize: '16px', lineHeight: '1.8', color: '#4b5563' }}>
          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '24px', fontWeight: '700', color: '#1f2937', marginBottom: '16px' }}>
              1. Acceptance of Terms
            </h2>
            <p>
              By accessing and using VentureOS ("the Service"), you accept and agree to be bound by these Terms of Service 
              ("Terms"). If you do not agree to these Terms, please do not use the Service. We reserve the right to update 
              these Terms at any time, and your continued use of the Service constitutes acceptance of any changes.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '24px', fontWeight: '700', color: '#1f2937', marginBottom: '16px' }}>
              2. Description of Service
            </h2>
            <p style={{ marginBottom: '16px' }}>
              VentureOS is an AI-powered venture capital intelligence platform that provides:
            </p>
            <ul style={{ paddingLeft: '24px', marginBottom: '16px' }}>
              <li style={{ marginBottom: '8px' }}>Deal sourcing and analysis tools</li>
              <li style={{ marginBottom: '8px' }}>Due diligence automation</li>
              <li style={{ marginBottom: '8px' }}>Portfolio management features</li>
              <li style={{ marginBottom: '8px' }}>Market intelligence and analytics</li>
              <li style={{ marginBottom: '8px' }}>Risk assessment capabilities</li>
            </ul>
            <p>
              We reserve the right to modify, suspend, or discontinue the Service (or any part thereof) at any time with 
              or without notice.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '24px', fontWeight: '700', color: '#1f2937', marginBottom: '16px' }}>
              3. User Accounts and Registration
            </h2>
            <p style={{ marginBottom: '12px' }}>
              To access certain features of the Service, you must register for an account. You agree to:
            </p>
            <ul style={{ paddingLeft: '24px', marginBottom: '16px' }}>
              <li style={{ marginBottom: '8px' }}>Provide accurate, current, and complete information</li>
              <li style={{ marginBottom: '8px' }}>Maintain and promptly update your account information</li>
              <li style={{ marginBottom: '8px' }}>Maintain the security of your account credentials</li>
              <li style={{ marginBottom: '8px' }}>Notify us immediately of any unauthorized access</li>
              <li style={{ marginBottom: '8px' }}>Be responsible for all activities under your account</li>
            </ul>
            <p>
              You may not share your account with others or create multiple accounts. We reserve the right to suspend 
              or terminate accounts that violate these Terms.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '24px', fontWeight: '700', color: '#1f2937', marginBottom: '16px' }}>
              4. Acceptable Use
            </h2>
            <p style={{ marginBottom: '12px' }}>
              You agree not to:
            </p>
            <ul style={{ paddingLeft: '24px', marginBottom: '16px' }}>
              <li style={{ marginBottom: '8px' }}>Use the Service for any illegal or unauthorized purpose</li>
              <li style={{ marginBottom: '8px' }}>Violate any laws or regulations in your jurisdiction</li>
              <li style={{ marginBottom: '8px' }}>Interfere with or disrupt the Service or servers</li>
              <li style={{ marginBottom: '8px' }}>Attempt to gain unauthorized access to any part of the Service</li>
              <li style={{ marginBottom: '8px' }}>Transmit any viruses, malware, or harmful code</li>
              <li style={{ marginBottom: '8px' }}>Scrape, copy, or reverse engineer any part of the Service</li>
              <li style={{ marginBottom: '8px' }}>Use automated means to access the Service without permission</li>
              <li style={{ marginBottom: '8px' }}>Impersonate any person or entity</li>
            </ul>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '24px', fontWeight: '700', color: '#1f2937', marginBottom: '16px' }}>
              5. Intellectual Property Rights
            </h2>
            <p style={{ marginBottom: '16px' }}>
              The Service and its original content, features, and functionality are owned by VentureOS and are protected 
              by international copyright, trademark, patent, trade secret, and other intellectual property laws.
            </p>
            <p style={{ marginBottom: '16px' }}>
              You retain ownership of any content you submit to the Service ("User Content"). By submitting User Content, 
              you grant us a worldwide, non-exclusive, royalty-free license to use, reproduce, modify, and display such 
              content for the purpose of providing the Service.
            </p>
            <p>
              You may not use our trademarks, logos, or branding without our prior written consent.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '24px', fontWeight: '700', color: '#1f2937', marginBottom: '16px' }}>
              6. Payment and Subscription Terms
            </h2>
            <p style={{ marginBottom: '16px' }}>
              Some features of the Service require payment. By subscribing to a paid plan:
            </p>
            <ul style={{ paddingLeft: '24px', marginBottom: '16px' }}>
              <li style={{ marginBottom: '8px' }}>You agree to pay all fees associated with your subscription</li>
              <li style={{ marginBottom: '8px' }}>Fees are non-refundable except as required by law</li>
              <li style={{ marginBottom: '8px' }}>Subscriptions automatically renew unless cancelled</li>
              <li style={{ marginBottom: '8px' }}>We may change pricing with 30 days' notice</li>
              <li style={{ marginBottom: '8px' }}>Late payments may result in service suspension</li>
            </ul>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '24px', fontWeight: '700', color: '#1f2937', marginBottom: '16px' }}>
              7. Data and Privacy
            </h2>
            <p>
              Your use of the Service is also governed by our Privacy Policy. We collect, use, and protect your data as 
              described in our Privacy Policy. You are responsible for ensuring that any data you upload complies with 
              applicable laws and that you have the necessary rights to share such data.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '24px', fontWeight: '700', color: '#1f2937', marginBottom: '16px' }}>
              8. Disclaimers and Limitations of Liability
            </h2>
            <p style={{ marginBottom: '16px' }}>
              THE SERVICE IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED, 
              INCLUDING BUT NOT LIMITED TO WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NON-INFRINGEMENT.
            </p>
            <p style={{ marginBottom: '16px' }}>
              VentureOS does not guarantee:
            </p>
            <ul style={{ paddingLeft: '24px', marginBottom: '16px' }}>
              <li style={{ marginBottom: '8px' }}>The accuracy, completeness, or reliability of any data or analytics</li>
              <li style={{ marginBottom: '8px' }}>Uninterrupted or error-free operation of the Service</li>
              <li style={{ marginBottom: '8px' }}>That the Service will meet your specific requirements</li>
              <li style={{ marginBottom: '8px' }}>Investment success or specific financial outcomes</li>
            </ul>
            <p>
              TO THE MAXIMUM EXTENT PERMITTED BY LAW, VENTUREOS SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, 
              CONSEQUENTIAL, OR PUNITIVE DAMAGES ARISING OUT OF OR RELATED TO YOUR USE OF THE SERVICE.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '24px', fontWeight: '700', color: '#1f2937', marginBottom: '16px' }}>
              9. Indemnification
            </h2>
            <p>
              You agree to indemnify, defend, and hold harmless VentureOS and its officers, directors, employees, and agents 
              from any claims, liabilities, damages, losses, and expenses arising out of or related to your use of the Service, 
              violation of these Terms, or infringement of any rights of another party.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '24px', fontWeight: '700', color: '#1f2937', marginBottom: '16px' }}>
              10. Termination
            </h2>
            <p style={{ marginBottom: '16px' }}>
              We may terminate or suspend your account and access to the Service immediately, without prior notice, for any 
              reason, including but not limited to:
            </p>
            <ul style={{ paddingLeft: '24px', marginBottom: '16px' }}>
              <li style={{ marginBottom: '8px' }}>Breach of these Terms</li>
              <li style={{ marginBottom: '8px' }}>Fraudulent or illegal activity</li>
              <li style={{ marginBottom: '8px' }}>Non-payment of fees</li>
              <li style={{ marginBottom: '8px' }}>Upon your request</li>
            </ul>
            <p>
              Upon termination, your right to use the Service will immediately cease. We are not liable for any damages 
              resulting from termination.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '24px', fontWeight: '700', color: '#1f2937', marginBottom: '16px' }}>
              11. Governing Law and Dispute Resolution
            </h2>
            <p style={{ marginBottom: '16px' }}>
              These Terms shall be governed by and construed in accordance with the laws of [Jurisdiction], without regard 
              to its conflict of law provisions.
            </p>
            <p>
              Any disputes arising out of or related to these Terms or the Service shall be resolved through binding arbitration 
              in accordance with the rules of [Arbitration Body], except that either party may seek injunctive relief in court.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '24px', fontWeight: '700', color: '#1f2937', marginBottom: '16px' }}>
              12. General Provisions
            </h2>
            <ul style={{ paddingLeft: '24px', marginBottom: '16px' }}>
              <li style={{ marginBottom: '8px' }}><strong>Entire Agreement:</strong> These Terms constitute the entire agreement between you and VentureOS</li>
              <li style={{ marginBottom: '8px' }}><strong>Severability:</strong> If any provision is found unenforceable, the remaining provisions will remain in effect</li>
              <li style={{ marginBottom: '8px' }}><strong>Waiver:</strong> Failure to enforce any right or provision does not constitute a waiver</li>
              <li style={{ marginBottom: '8px' }}><strong>Assignment:</strong> You may not assign these Terms without our consent</li>
              <li style={{ marginBottom: '8px' }}><strong>No Agency:</strong> Nothing in these Terms creates a partnership, joint venture, or agency relationship</li>
            </ul>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '24px', fontWeight: '700', color: '#1f2937', marginBottom: '16px' }}>
              13. Contact Information
            </h2>
            <p style={{ marginBottom: '12px' }}>
              If you have any questions about these Terms, please contact us at:
            </p>
            <div style={{ 
              padding: '20px', 
              backgroundColor: '#f9fafb', 
              borderRadius: '8px',
              borderLeft: '4px solid #6366f1'
            }}>
              <p style={{ marginBottom: '8px' }}><strong>Email:</strong> legal@ventureos.com</p>
              <p style={{ marginBottom: '8px' }}><strong>Address:</strong> VentureOS Inc.</p>
              <p>For legal inquiries, please mark your communication as "Terms of Service"</p>
            </div>
          </section>
        </div>

        {/* Back to Home */}
        <div style={{ textAlign: 'center', marginTop: '80px', paddingTop: '60px', borderTop: '2px solid #e5e7eb' }}>
          <a 
            href="/" 
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '8px',
              padding: '14px 28px',
              color: '#6b7280',
              border: '2px solid #e5e7eb',
              borderRadius: '12px',
              fontWeight: '600',
              textDecoration: 'none',
              fontSize: '16px',
              transition: 'all 0.2s ease'
            }}
          >
            ← Back to Home
          </a>
        </div>
      </div>
    </div>
  );
};

export default Terms;
